<template>
  <div class="exerciseDetail">
    <Header
      :pageTitle="'练习结果'"
      :isXue="isXue"
      @backFn="backFn"
      v-if="isApp"
    >
    </Header>
    <!-- 答题进度 -->
    <div class="exerciseResult">
      <!--  <div class="eResultText">
        <img class="icon-clock" src="@/assets/icon/icon_clock.png" alt="" />
        <p>
          共用时{{ ResultData.readableTimeTotal }}，超过{{
            ResultData.winning
          }}%的同学
        </p>
      </div> -->
      <div class="rProgress" style="justify-content: center">
        <div class="cirleCont">
          <div class="cirleSvg">
            <svg
              id="demo"
              width="120"
              height="120"
              viewBox="0 0 120 120"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M101.567 86.9564C103.365 84.2721 104.911 81.4059 106.168 78.3914C108.637 72.4747 110 65.9869 110 59.1829C110 31.4676 87.3904 9 59.5 9C31.6096 9 9 31.4676 9 59.1829C9 65.9869 10.3627 72.4747 12.8316 78.3914C14.0895 81.4059 15.6345 84.2721 17.4328 86.9564"
                stroke="#E1E2E6"
                stroke-width="4.8"
                stroke-linecap="round"
              />
              <path
                ref="doctorCircle"
                id="bur-a"
                d="M101.567 86.9564C103.365 84.2721 104.911 81.4059 106.168 78.3914C108.637 72.4747 110 65.9869 110 59.1829C110 31.4676 87.3904 9 59.5 9C31.6096 9 9 31.4676 9 59.1829C9 65.9869 10.3627 72.4747 12.8316 78.3914C14.0895 81.4059 15.6345 84.2721 17.4328 86.9564"
                stroke="#6183F2"
                stroke-width="6"
                stroke-linecap="round"
                stroke-dasharray="218"
                stroke-dashoffset="218"
              />
            </svg>
            <!-- <svg
              width="100"
              height="100"
              viewBox="0 0 100 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M89.1517 76C90.8253 73.4864 92.2632 70.8024 93.4339 67.9796C95.7318 62.4391 97 56.3638 97 49.9923C97 24.0392 75.9574 3 50 3C24.0426 3 3 24.0392 3 49.9923C3 56.3638 4.26823 62.4391 6.56606 67.9796C7.73675 70.8024 9.1747 73.4864 10.8483 76"
                stroke="#E1E2E6"
                stroke-width="6"
                stroke-linecap="round"
              />
              <path
                ref="doctorCircle"
                id="bur-a"
                d="M89.1517 76C90.8253 73.4864 92.2632 70.8024 93.4339 67.9796C95.7318 62.4391 97 56.3638 97 49.9923C97 24.0392 75.9574 3 50 3C24.0426 3 3 24.0392 3 49.9923C3 56.3638 4.26823 62.4391 6.56606 67.9796C7.73675 70.8024 9.1747 73.4864 10.8483 76"
                stroke="#6183F2"
                stroke-width="6"
                stroke-dasharray="210"
                stroke-dashoffset="0"
                stroke-linecap="round"
              />
            </svg> -->
            <div class="correctRate">
              <span>{{
                ResultData.objectiveRatio
                  ? ResultData.objectiveRatio + ' %'
                  : '0 %'
              }}</span>
              <div class="correctText">正确率</div>
              <div class="objective">客观题</div>
            </div>
          </div>
          <!--  <div class="doctor-answer-circle" ref="doctorCircle">
            <div
              class="
                doctor-answer-circle-process
                flex-column
                align-items
                justify-content
              "
            >
              <strong>{{
                ResultData.objectiveRatio
                  ? ResultData.objectiveRatio + ' %'
                  : '0 %'
              }}</strong>
              <span>正确率</span>
            </div>
          </div> -->
        </div>
        <!--  <div class="cirleCont" v-if="ResultData.subjectiveFinishedCount">
          <div class="doctor-answer-circle" ref="finshCircle">
            <div
              class="
                doctor-answer-circle-process
                flex-column
                align-items
                justify-content
              "
            >
              <strong>{{
                ResultData.subjectiveFinishedCount
                  ? ResultData.subjectiveFinishedCount
                  : '0'
              }}</strong>
              <span>完成数</span>
            </div>
          </div>
          <p>主观题/观点题</p>
        </div> -->
      </div>
      <div class="resultnumBox">
        <div class="completed">
          <div class="completedImg">
            <img src="@/assets/icon/proportion_light.png" alt="" />
          </div>
          <div class="completedNum">
            <div class="completedTitle">主观题</div>
            <div class="completedVal">
              <span>
                {{
                  ResultData.subjectiveFinishedCount
                    ? ResultData.subjectiveFinishedCount
                    : '无'
                }}</span
              >
              完成数
            </div>
          </div>
        </div>
        <span class="completedLine"></span>
        <div class="completed">
          <div class="completedImg">
            <img src="@/assets/icon/lock_time.png" alt="" />
          </div>
          <div class="completedNum">
            <div class="completedTitle">共用时</div>
            <div class="completedVal">
              <span>{{ ResultData.readableTimeTotal }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exerciseItem_content">
      <div class="exerciseItem_title">
        <span>练习记录</span>点击题号，可查看对应解析
      </div>
      <ul class="exerciseItem">
        <li
          class="exerciseList"
          v-for="(item, index) in ResultData.answers"
          :key="index"
          :class="
            item.questionType === 'TEXT' || item.questionType === 'OPINION'
              ? 'exerciseWhite'
              : item.result === true
              ? 'exerciseBlue'
              : 'exerciseRed'
          "
          @click.stop="goExercise(item.position)"
        >
          {{ item.position }}
        </li>
      </ul>
      <div class="feedback" v-show="evaluateSucc">
        <div class="feedbackTitle">
          <span>您的反馈有助于内容持续改善</span>
        </div>

        <ul>
          <li
            v-for="(item, index) in evaluateList"
            :key="index"
            @click.stop="selectEvaluate(item)"
          >
            {{ item.value }}
          </li>
        </ul>
      </div>
      <div class="feedback" v-show="evaluateShow" @click.stop="evalueShow">
        <div class="feedbackSuccess">
          <div class="feedbackTitle">
            <img src="@/assets/icon/icon_success.png" alt="" />
            <span class="reviewReceived">评价已收到</span>
          </div>
          <div class="feedbackTips">感谢您的反馈，我们会持续改进</div>
          <ul>
            <li class="feedbackContent">{{ evaluateLable }}</li>
          </ul>
        </div>
      </div>
    </div>
    <!--    <ul class="eDevelop">
          <div class="rTitle">进一步提升，我可以学习</div>
          <li class="eDevelopList">
            <div class="eListLeft">
              <div class="eListTitle">心电图的临床鉴别专题一</div>
              <div class="eListText">这是个副标题这是个副标题</div>
              <div class="eListBtn">免费</div>
    &lt;!&ndash;          <div class="eListBtn">专享</div>&ndash;&gt;
            </div>
            <img src="@/assets/icon/icon_star.png" alt="">
          </li>
        </ul>-->

    <div class="submitContainer">
      <div class="submitWrapper">
        <div class="btn btnStyle" @click.stop="backFn">返回</div>
        <div class="btn" @click.stop="reStart">重新练习</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { exerReq } from '@/api/index'
import Header from '@/components/common/Header.vue'
import { customerAct } from '@/api/data'
import {
  appPort,
  iOSPort,
  androidPort,
  closeWebView,
  getUserId,
  hiddenAppNavBar,
  userLogin,
  validateXue,
  closeAppView
} from '@/widget'
// import findIndex from 'lodash/findIndex'

export default defineComponent({
  data() {
    return {
      ResultData: {},
      isApp: appPort(),
      quizId: '',
      isGuest: '',
      depObj: {
        1: '骨科',
        2: '心血管',
        9: '整形外科',
        11: '口腔外科',
        13: '肿瘤科'
      },
      courseInfo: {
        practice_ID: '',
        practice_name: '',
        course_ID: '',
        course_name: ''
      },
      depId: '',
      favour: this.$route.query.favour === 'true', // app 收藏页进入该页面
      sourceInfo: this.$route.query.sourceInfo === 'recommend', // app 推荐页进入该页面
      evaluateList: [
        {
          lable: 'DIFFICULT',
          value: '受益匪浅'
        },
        {
          lable: 'GAIN',
          value: '有所启发'
        },
        {
          lable: 'EASY',
          value: '无显著帮助'
        }
      ],
      evaluateLable: null,
      evaluateShow: false,
      evaluateSucc: true,
      result: false,
      flag: true,
      isXue: validateXue()
    }
  },
  methods: {
    backFn() {
      if (!this.flag) {
        return
      }
      this.flag = false
      if (this.isApp) {
        if (this.isXue) {
          closeAppView()
          return
        }
        if (this.favour || this.sourceInfo) {
          closeWebView()
        } else {
          if (this.ResultData.exerciseType === 'MEDICASE') {
            this.toMedicaseHome()
          } else {
            closeWebView()
            // jumpModuleApp({
            //   typeId: 'exercise_home',
            //   dataId: Number(this.$route.params.id) || 0,
            //   type: this.ResultData.exerciseType
            // })
          }
        }
      } else {
        // let query = this.getQuery()
        // let exerciseId = this.$route.query.exerciseId
        // if (this.ResultData.exerciseType === 'MEDICASE') {
        //   this.toMedicaseHome()
        // } else if (exerciseId) {
        //   this.$router.replace({
        //     path: '/exam/' + exerciseId,
        //     query
        //   })
        // } else {
        //   this.toMedicaseHome()
        // }
        history.go(-1)
      }
      setTimeout(() => {
        this.flag = true
      }, 100)
    },
    toMedicaseHome() {
      history.go(-1)
    },
    setProcess(doctorCircle, process) {
      var endProcess
      if (process === 0) {
        endProcess = 218
      } else if (process === 100) {
        endProcess = 236 + process * 2
      } else {
        endProcess = 230 + process * 2
      }
      doctorCircle.style.strokeDashoffset = endProcess
      /*  const realFunc = () => {
        startProcess += endProcess * (1 / 100)
        startProcess = startProcess > endProcess ? endProcess : startProcess
        let deg = -360 * startProcess - 90
        if (deg <= -360) {
          deg += 360
        }
        doctorCircle.style.background = `linear-gradient(${
          startProcess > 0.5
            ? `-90deg, transparent 50%, #85A1FF`
            : `90deg, transparent 50%, #EFEFEF`
        }
50%),linear-gradient(${deg}deg, #85A1FF 50%, #EFEFEF 50%)`
        if (startProcess >= endProcess) {
          window.cancelAnimationFrame(timer)
          return
        }
        timer = window.requestAnimationFrame(realFunc)
      }
      realFunc() */
    },
    getResult() {
      exerReq
        .getResult({
          quizId: this.quizId
        })
        .then(res => {
          if (Number(res.code) === 200) {
            let { paperId, exerciseType } = res.data
            if (exerciseType === 'MEDICASE') {
              let userId = getUserId()
              customerAct(
                {
                  userId,
                  typeText: 'exercise_lesson_navigation_answer'
                },
                {
                  extra: JSON.stringify({
                    paperId: paperId
                  })
                }
              ).then(res => {
                // console.log(res.code)
              })
            }
            this.$hideLoading()
            this.ResultData = res.data
            this.objectiveRatio = res.data.objectiveRatio
            /* 用户反馈 */
            if (res.data.feedbackType != null) {
              this.evaluateShow = true
              this.evaluateSucc = false
              this.evaluateLable = res.data.feedbackTypeName
            }
            this.isGuest = res.data.isGuest
            this.purchased = res.data.purchased
            if (this.isGuest === true) {
              this.getGuest()
            }
            this.subjectiveFinishedCount = res.data.subjectiveFinishedCount
            this.setProcess(this.$refs.doctorCircle, this.objectiveRatio)
            // this.setProcess(
            //   this.$refs.finshCircle,
            //   parseInt(
            //     (this.subjectiveFinishedCount /
            //       this.ResultData.subjectiveTotal) *
            //       100
            //   )
            // )
            document.title = res.data.paperName

            this.depId = res.data.departmentId
            this.courseInfo.practice_ID = res.data.paperId
            this.courseInfo.practice_name = res.data.paperName
            this.courseInfo.course_ID = res.data.exerciseId
            this.courseInfo.course_name = res.data.exerciseName
            this.setGio(
              'ViewPracticeDetail',
              this.depObj[this.depId],
              this.courseInfo,
              res.data.exerciseType
            )

            if (!this.isApp && !res.data.isOwner) {
              let query = this.$route.query
              query.taskId = res.data.taskId
              query.questionId = res.data.firstQuestionId
              this.$router.replace({
                query,
                path: `/detail/exam/${this.$route.params.id}`
              })
            }
          } else {
            this.$hideLoading()
            this.$toast(res.message)
          }
        })
    },
    getGuest() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '想要解锁更多病例练习',
          confirmButtonText: '去登录'
        })
        .then(() => {
          userLogin()
        })
    },
    goExercise(val) {
      const id = this.$route.params.id
      let query = {
        quizId: this.ResultData.quizId,
        position: val,
        previous: '1'
      }
      if (this.favour) {
        query.favour = true
      }
      if (this.isXue) {
        query.xue = 1
      }
      if (this.sourceInfo) {
        query.sourceInfo = 'recommend'
      }
      this.$router.replace({
        path: `/detail/exercise/${id}`,
        query
      })
    },
    reStart() {
      this.$showLoading()
      let { exerciseId, planId, type, depId } = this.$route.query
      const id = this.$route.params.id
      let query = {
        taskId: this.ResultData.taskId,
        paperId: this.ResultData.paperId,
        quizId: this.ResultData.quizId,
        isStart: 1,
        exerciseId: exerciseId || '',
        planId: planId || '',
        type: type || '',
        depId: this.depId || depId || ''
      }
      if (this.favour) {
        query.favour = true
      }
      if (this.isXue) {
        query.xue = 1
      }
      if (this.sourceInfo) {
        query.sourceInfo = 'recommend'
      }
      if (/\d+/.test(this.ResultData.taskId)) {
        this.$router.replace({
          path: `/detail/exercise/${id}`,
          query
        })
      }
    },
    getQuery() {
      let { exerciseId, planId, type, depId, sourceId } = this.$route.query
      let query = {}
      if (sourceId) {
        query.sourceId = sourceId
      }
      return {
        ...query,
        exerciseId: exerciseId || '',
        planId: planId || '',
        type: type || '',
        depId: this.depId || depId || ''
      }
    },
    setGio(type, dep, obj, module) {
      // obj practice_ID
      // course_ID
      // course_name
      // moduleType
      let info = Object.assign(obj, {
        platform: this.portInfo(),
        departmentType: dep,
        moduleType: this.getModule(module),
        practicePageType: '答题结果页'
      })
      if (window.gio) {
        // ViewPracticeDetail
        // click_sharing_practiceDetail
        gio('track', type, info)
      }
    },
    portInfo() {
      if (appPort()) {
        if (iOSPort()) {
          return 'iOS'
        } else if (androidPort()) {
          return '安卓'
        }
      } else {
        return 'H5'
      }
    },
    getModule(type) {
      let str = ''
      switch (type) {
        case 'OMO':
          str = 'OMO'
          break
        case 'TEAM':
          str = 'online'
          break
        case 'INDIVIDUAL':
          str = 'AIexercise'
          break
      }
      return str
    },
    /* 选择答题反馈 */
    selectEvaluate(val) {
      this.evaluateLable = val.value
      this.feedback(val.lable)
    },
    evalueShow() {
      this.evaluateShow = false
      this.evaluateSucc = true
    },
    feedback(type) {
      this.$showLoading()
      exerReq
        .userFeedback({
          quizId: this.quizId,
          feedbackType: type
        })
        .then(res => {
          if (res.code === 200) {
            this.$hideLoading()
            this.result = res.data.result
            if (this.result === true) {
              this.evaluateShow = true
              this.evaluateSucc = false
            }
          } else {
            this.$hideLoading()
            this.$toast(res.message)
          }
        })
    }
  },
  mounted() {
    if (appPort()) {
      hiddenAppNavBar()
    }
    this.quizId = this.$route.query.quizId
    this.getResult()
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  components: {
    Header
  }
})
</script>
<style scoped>
svg #bur-a {
  transition: all 0.5s ease-in;
}
:root {
  --van-button-border-width: 0;
  --van-button-primary-border-color: #fff;
}
button {
  outline: none;
  border: none;
}
</style>
<style lang="scss">
.van-circle__text {
  font-family: DINEngschrift;
  font-size: 32px;
  color: #212224;
  line-height: 66px;
}
</style>
<style lang="scss" scoped>
@font-face {
  font-family: DINEngschrift;
  src: url('~@/assets/fonts/DINEngschrift.otf');
}
.exerciseDetail {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f7;
  overflow: hidden;
}
.exerciseResult {
  //padding: 32px 32px;
  position: relative;
  left: 32px;
  top: 32px;
  .eResultText {
    padding: 24px 0;
    display: flex;
    align-items: center;
    img {
      width: 26px;
      height: 26px;
      margin-right: 14px;
    }
    p {
      font-size: 24px;
      font-family: PingFangSC-Bold, PingFang SC;
      font-weight: bold;
      color: #212224;
      line-height: 34px;
    }
  }
  .resultnumBox {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 686px;
    height: 154px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .completed {
      width: 50%;
      display: flex;
      justify-content: center;
    }
    .completedImg {
      width: 40px;
      height: 40px;
      margin-right: 8px;
      line-height: 160px;
      img {
        width: 100%;
      }
    }
    .completedTitle {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #969799;
      line-height: 34px;
    }
    .completedLine {
      width: 2px;
      height: 88px;
      background: #e1e2e6;
    }
    .completedNum {
      display: flex;
      flex-direction: column;
      line-height: 40px;
      margin-top: 6px;
      .completedVal {
        margin-top: 10px;
        span {
          font-size: 44px;
          font-family: DINEngschrift;
          color: #212224;
        }
      }
    }
  }
}
.rProgress {
  width: 686px;
  height: 456px;
  background: url('~@/assets/img/exercise/practiceResults.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  //align-items: center;
  margin-bottom: 56px;
  //padding: 56px 64px;
  .cirleCont {
    /*width: 210px;*/
    position: relative;
    display: flex;
    align-items: center;
    flex-flow: column;
    .cirleSvg {
      position: relative;
      top: 60px;
      text-align: center;
      .correctRate {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span {
          font-size: 56px;
          font-family: DINEngschrift;
          color: #212224;
          line-height: 66px;
        }
        .correctText {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #969799;
          line-height: 34px;
        }
        .objective {
          margin-top: 15px;
          bottom: 1px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #626366;
          line-height: 34px;
        }
      }
    }
    .doctor-answer-circle {
      width: 202px;
      height: 202px;
      border-radius: 50%;
      padding: 12px;
      margin-top: 60px;
      position: relative;
    }
    .doctor-answer-circle-process {
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      strong {
        width: 100%;
        height: 0.6rem;
        font-family: DINEngschrift;
        font-size: 56px;
        text-align: center;
      }
      span {
        font-size: 24px;
        color: #969799;
        margin-top: 20px;
      }
    }
    p {
      padding-top: 10px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #626366;
    }
  }
}

.exerciseItem_content {
  background: #ffffff;
  margin: 32px;
  .exerciseItem_title {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #969799;
    line-height: 40px;
    padding: 40px 32px 0;
    span {
      font-size: 40px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212224;
      line-height: 56px;
      margin-right: 8px;
    }
  }
  .exerciseItem {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-bottom: 18px;
    padding: 56px 21px;
    .exerciseList {
      width: 88px;
      height: 88px;
      border-radius: 50%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 20px 48px 20px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .exerciseBlue {
      background: #6183f2;
      color: #ffffff;
    }
    .exerciseRed {
      background: #f95046;
      color: #ffffff;
    }
    .exerciseWhite {
      background-color: #f5f5f7;
      color: #212224;
    }
  }
  .feedbackSuccess {
    width: 622px;
    height: 278px;
    background: rgba(245, 245, 247, 0);
    border-radius: 12px;
    border: 2px solid #f5f5f7;
    margin: 0 17px;
    .feedbackTitle {
      padding-top: 48px;
    }
    ul {
      padding-bottom: 48px;
      .feedbackContent {
        background: #f5f5f7;
      }
    }
  }
  .feedback {
    text-align: center;
    padding-bottom: 200px;
    margin: 0px 15px;
    .feedbackTitle {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .reviewReceived {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212224;
        line-height: 50px;
      }
      span {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #969799;
        line-height: 44px;
        margin: 0 11px;
      }
      p {
        display: inline-block;
        width: 80px;
        height: 1px;
        background: #e1e2e6;
      }
      img {
        width: 40px;
        height: 40px;
      }
    }
    .feedbackTips {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #626366;
      line-height: 40px;
      margin-top: 10px;
    }
    ul {
      display: flex;
      justify-content: space-around;
      padding-top: 32px;
      li {
        width: 180px;
        height: 56px;
        background: #ffffff;
        border-radius: 8px;
        border: 2px solid #e1e2e6;
        line-height: 56px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626366;
      }
    }
  }
}

.rTitle {
  font-size: 36px;
  font-family: PingFangSC-Bold, PingFang SC;
  font-weight: bold;
  color: #212224;
  margin-bottom: 28px;
}
.eAnalysis {
  padding-bottom: 32px;
  .eAnalysisItem {
    .eAnalysisList {
      padding: 16px 20px;
      border-radius: 12px;
      border: 2px solid #f5f5f7;
      margin-bottom: 16px;
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #626366;
      }
      .eAnalysisStar {
        margin-top: 10px;
        img {
          width: 32px;
          height: 32px;
          margin-right: 4px;
          display: inline-block;
        }
      }
    }
  }
}
.eDevelop {
  padding: 66px 32px;
  .eDevelopList {
    background: #ffffff;
    border-radius: 16px;
    padding: 28px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .eListLeft {
      max-width: 370px;
      .eListTitle {
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #212224;
        margin-bottom: 8px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .eListText {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #969799;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .eListBtn {
        margin-top: 50px;
        width: 120px;
        height: 48px;
        line-height: 48px;
        background: rgba(255, 255, 255, 0);
        border-radius: 31px;
        border: 1px solid #ff6c00;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        text-align: center;
        color: #ff6c00;
      }
    }
    img {
      flex-shrink: 0;
      width: 248px;
      height: 186px;
      border-radius: 12px;
      margin-left: 28px;
    }
  }
}
.submitContainer {
  width: 750px;
  height: 128px;
  margin: 0 auto;
  font-size: 32px;
  .submitWrapper {
    height: 128px;
    width: 750px;
    box-sizing: border-box;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    margin-left: -375px;
    background: #fff;
    box-shadow: 0 1px rgba(177, 177, 179, 0.25) inset;
  }
  .btn {
    width: 100%;
    height: 88px;
    border-radius: 44px;
    text-align: center;
    line-height: 88px;
    text-align: center;
    background: #ff6600;
    color: #fff;
    font-weight: 600;
  }
  .btnStyle {
    background: #f5f5f7;
    color: #ff6600;
    margin-right: 24px;
  }
}
</style>
